import { Component, Inject, OnDestroy, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
  selector: 'must-login-snack',
  template: `
  <div matSnackBarLabel>
    <div>You must be logged in to perform this action.</div>
  </div>
  <div matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">Login</button>
  </div>
  `,
  styles: [
    `
    :host {
      display: flex;
    }
  `,
  ],
  standalone: true,
  imports: [MatButtonModule, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
})
export class MustLoginSnackComponent implements OnDestroy {
  snackBarRef = inject(MatSnackBarRef);
  time = 15;
  int
  constructor(
   
  ){ // Could used this to force them to the login page unless they dismiss, but for now just standard
    this.time = 10;
    this.int = setInterval(() => {
      this.time = this.time - 1;
      console.log('called ', this.time)
      if(this.time === 1) {
        clearInterval(this.int);
        this.snackBarRef.dismiss();
      }
    }, 1000)
  }

  ngOnDestroy(): void {
    if(this.int) clearInterval(this.int);
  }
}
